import type { ReactNode } from 'react'
import AudioCtx from './audio'
import MessagesCtx from './messages'

interface Props {
  children: ReactNode
}

const Providers = ({ children }: Props) => (
  <MessagesCtx.Provider>
    <AudioCtx.Provider>
      {children}
    </AudioCtx.Provider>
  </MessagesCtx.Provider>
)

export default Providers
